import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput } from '../theme/index';
import styled from '@mui/material/styles/styled';
import { UseScreen } from '../hooks/UseScreen.hook';
import { useDispatch, useSelector } from 'react-redux';
import SuccessModal from '../components/SuccessModal';
import { useNavigate } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ProductTable from '../components/datatables/Products';
import { modalAction } from '../redux/reducers/Modal';
import { searchAction } from '../redux/reducers/Search';

const Room = styled(Grid)(({ theme }) => `
    :hover{
      cursor: pointer
    }
`)

const createReservationRoute = '/bookings';

const Product = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const modalStatus = useSelector( state => state.Modal.modalState );
  const navigate = useNavigate();

  const [ showModal, setShowModal ] = useState(false);
  const [ modalForm, setModalForm ] = useState('');

  useEffect( () => {
    setShowModal(modalStatus);
    if( !modalStatus ) {
      setModalForm('');
    }
  }, [modalStatus] );

  const createClient = () => {
    dispatch(modalAction());
    setModalForm('newProduct');
  }

  const btnFilter = () => {
    return ( screenWidth <= 500 ) ? { width: '100%', marginBottom: '1rem' } : { width: '90%' };
  }
  
  return (
    <Grid container px={4}>
      <Grid item xs={12}>
        <h2 style={{ fontFamily: 'Roboto-Thin' }}>Productos</h2>
      </Grid>
      {
        showModal &&
          <SuccessModal view={modalForm} />
      }
      <Grid container sx={{ mt: 5, justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
        <Grid item xs={12} sm={3} md={2} sx={{ mb: 4 }}>
          <PrimaryOutlinedButton sx={{ width: '100%' }} onClick={ () => createClient() }>Nuevo producto</PrimaryOutlinedButton>
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <PrimaryLightInput
            placeholder='Buscar producto'
            type='text'
            sx={{ width: '100%' }}
            onChange={ e => dispatch(searchAction(e.target.value)) }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ mt: 5, mb: 3 }}>
          <ProductTable />
      </Grid>
    </Grid>
  )
}

export default Product